/**
 *
 * Common form classNames for BC Vosdvizhenka(14691)
 *
 */

export const helperTextClassName = 'BC_Vosdvizhenka-14691-advanced-form-field-helper-text';